export default __webpack_public_path__ + "images/35341fa92b4cae26cd6560b6520fe8ba.png";